// import { useDispatch,useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
// import Dashboard from './pages/userDashboard/UserDashbord';
import Mainlayout from "./Mainlayout";
import Register from "./pages/reg/Register";
import Login from "./pages/Login/Login";
import Admin from "./pages/admin/Admin";
import Admin1 from "./pages/admin/admin1";
import OTPPage from "./pages/reg/otp2";
import OtpPage from "./pages/forgotpass/fremailotp";
import ForgottenPassword from "./pages/forgotpass/fremail";
import Passchange from "./pages/forgotpass/pemailup";
import UserDashboard from "./UserDashboard";
import InvestorTransaction from "./components/investorTransactions/InvestorTransaction";
import Homepagelayout from "./HomepageLayout";
import { AuthContext } from './authcontext/authContext';
import { useContext} from "react";

function App() {

  const { currentUser } = useContext(AuthContext);

  return (
    <Router>
      <meta name="viewport" content="width=1024" />

      <Routes>
        <Route path="/" element={<Homepagelayout />} />
        <Route path="*" element={<Mainlayout />} />
        {/* <Route path="/dashboard" element={<UserDashboard />} /> */}
        <Route path='/dashboard' element={currentUser ? <UserDashboard  /> : <Login/>}/>
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verifyemail" element={<ForgottenPassword />} />
        <Route path='/admin' element={currentUser?.is_admin === 1 ? <Admin1 /> : <Login/>} />
        <Route path="/emailverify" element={<OTPPage />} />
        <Route path="/verifyotp" element={<OtpPage />} />
        <Route path="/passchange" element={<Passchange />} />
        <Route
          path="/alltransactions/:useId"
          element={<InvestorTransaction />}
        />
      </Routes>
    </Router>
  );
}

export default App;

// App.js

// // App.js
// import React, { useContext } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Dashboard from './pages/userDashboard/UserDashbord';
// import Mainlayout from './Mainlayout';
// import Register from './pages/reg/Register';
// import Login from './pages/Login/Login';
// import Admin from './pages/admin/Admin';
// import  AuthContext  from './authcontext/authContext';

// const App = () => {
//   const { currentUser } = useContext(AuthContext);

//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Mainlayout />}>
//           <Route path="/register" element={<Register />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/admin" element={<Admin />} />
//         </Route>
//       </Routes>
//     </Router>
//   );
// };

// export default App;
